import Model, { attr, belongsTo } from "@ember-data/model";
import { task } from "ember-concurrency";
import type Database from "glesys-controlpanel/models/database";
import type { Type } from "@warp-drive/core-types/symbols";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class InstanceDatabaseModel extends Model {
  @attr declare name: string;

  @belongsTo<Database>("database", { async: false, inverse: "instanceDatabases" }) declare database: Database;

  deleteTask = task(async () => {
    try {
      this.deleteRecord();
      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();
      throw error;
    }
  });

  declare [Type]: "instance-database";
}
